var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTicket(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 9H16.5V11.5H15.5V9ZM15.5 15H16.5V12.5H15.5V15ZM19 12C19 13.3785 20.1215 14.5 21.5 14.5H22V18.5H2V14.5H2.5C3.87848 14.5 5 13.3785 5 12C5 10.6215 3.87848 9.5 2.5 9.5H2V5.5H22V9.5H21.5C20.1215 9.5 19 10.6215 19 12ZM21 8.53558V6.5H16.5V8H15.5V6.5H3V8.53558C4.69391 8.77899 6 10.2398 6 12C6 13.7602 4.69391 15.221 3 15.4644V17.5H15.5V16H16.5V17.5H21V15.4644C19.3061 15.221 18 13.7602 18 12C18 10.2398 19.3061 8.77899 21 8.53558Z",
    fill: "#656A6F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicket);
export default __webpack_public_path__ + "static/media/ticket.32bec22057bb14e9de1ed40114a00519.svg";
export { ForwardRef as ReactComponent };